'use strict';

var IS_NODE = require('../internals/engine-is-node');
module.exports = function (name) {
  try {
    // eslint-disable-next-line no-new-func -- safe
    if (IS_NODE) return Function('return require("' + name + '")')();
  } catch (error) {/* empty */}
};